export default __webpack_public_path__ + "static/media/microsoft.60bc550b.svg";